export const SET_PARAMETERS   = 'SET_PARAMETERS';
export const UPDATE_PARAMETER = 'UPDATE_PARAMETER';
